import { useEffect, useMemo, useState } from 'react'
import {
    CommonConstant,
    ErrorConstant,
    CompanyService,
    PaginationType,
} from 'utility'

export const GetCompanyList = (paginationType = PaginationType.default) => {
    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [totalCount, setTotalCount] = useState(0)
    const [filter, setFilter] = useState({
        PageNumber: 1,
        PageSize: CommonConstant.defaultPageSize,
        all: paginationType,
    })

    const options = useMemo(() => {
        data?.map(ele => ({
            value: ele.TemplateId,
            text: ele.TemplateName,
        }))
    }, [data])

    const fetchData = async () => {
        try {
            setLoading(true)
            const result = await CompanyService.list(
                !filter.all ? filter : { ...filter, PageSize: 5000000 },
            )
            setData(result.Items)
            setTotalCount(result.TotalCount)
        } catch {
            setError(ErrorConstant.default)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [filter])

    const pageChanged = page => {
        setFilter({
            ...filter,
            PageNumber: page,
        })
    }

    const refresh = () => {
        setFilter({
            ...filter,
        })
    }

    const filterChanged = data => {
        setFilter({
            ...filter,
            ...data,
        })
    }

    return {
        data,
        setData,
        options,
        error,
        loading,
        filter,
        totalCount,
        pageChanged,
        refresh,
        filterChanged,
    }
}

export const GetAuditCompanyList = (enabled = true, isPaginated = false, initialPageSize = 25) => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [totalCount, setTotalCount] = useState(0)
    const [filter, setFilter] = useState({
        PageNumber: 1,
        PageSize: initialPageSize,
        search: '',
    })

    const options = useMemo(
        () =>
            data?.map(ele => ({
                key: ele.CompanyId,
                value: ele.CompanyId,
                text: ele.CompanyName,
            })) || [],
        [data],
    )

    const fetchData = async () => {
        if (!enabled) return
        try {
            setLoading(true)
            const queryParams = isPaginated ? filter : undefined
            const result = await CompanyService.getAuditCompanies(queryParams)
            if (result && Array.isArray(result.Items)) {
                setData(result.Items)
                setTotalCount(result.TotalCount || 0)
            } else {
                setData(result || [])
                setTotalCount(result?.length || 0)
            }
        } catch (e) {
            console.error(e)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [enabled, isPaginated, JSON.stringify(filter)])

    const pageChanged = page => {
        setFilter(prev => ({
            ...prev,
            PageNumber: page,
        }))
    }

    const filterChanged = updatedFilter => {
        setFilter(prev => ({
            ...prev,
            ...updatedFilter,
            PageNumber: 1,
        }))
    }

    const refresh = () => {
        fetchData()
    }

    return {
        data,
        options,
        loading,
        totalCount,
        filter,
        pageChanged,
        filterChanged,
        refresh,
    }
}
